import styled from 'styled-components';

export const Container= styled.div`
    position:fixed;
    overflow-y: scroll;
    width: 100%;
    top: 64px;
    height: calc(100vh - 120px);
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    background: rgba(21, 22, 49, 0.92);
    z-index:120;
`;

export const Header = styled.span`
    margin-top:20px;
    font-family: Nunito;
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 140%;
    color: #FAFAFA;
`;

export const Details = styled(Header)`
    margin-top:7px;
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    font-size: 14px;
    font-weight: 400;
`;